import { render } from "./TitleH2.vue?vue&type=template&id=3bce8f0b&scoped=true"
import script from "./TitleH2.vue?vue&type=script&lang=js"
export * from "./TitleH2.vue?vue&type=script&lang=js"

import "./TitleH2.vue?vue&type=style&index=0&id=3bce8f0b&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bce8f0b"]])

export default __exports__